import { SvgIcon } from '@frontierag/frontier-ui-library';
import { sharedMuiTheme } from '@frontierag/frontier-ui-library';

export default function CustomCalculatorIcon({ isDisabled = false }) {
  const stroke = isDisabled ? sharedMuiTheme.palette.grey.L60 : sharedMuiTheme.palette.naval.L40;
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="custom-calculator-icon"
      >
        <path
          d="M16.5 6.89941V7.89941C16.5 8.71941 15.83 9.39941 15 9.39941H9C8.18 9.39941 7.5 8.72941 7.5 7.89941V6.89941C7.5 6.07941 8.17 5.39941 9 5.39941H15C15.83 5.39941 16.5 6.06941 16.5 6.89941Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.13623 13.3203H8.14778"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.995 13.3203H12.0066"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8544 13.3203H15.8659"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.13612 16.8203H8.14767"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.995 16.8203H12.0066"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8544 16.8203H15.8659"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 21.25H9C6.57397 21.25 5.07086 20.7602 4.15533 19.8447C3.2398 18.9291 2.75 17.426 2.75 15V9C2.75 6.57397 3.2398 5.07086 4.15533 4.15533C5.07086 3.2398 6.57397 2.75 9 2.75H15C17.426 2.75 18.9291 3.2398 19.8447 4.15533C20.7602 5.07086 21.25 6.57397 21.25 9V15C21.25 17.426 20.7602 18.9291 19.8447 19.8447C18.9291 20.7602 17.426 21.25 15 21.25Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
